import React from "react";

import Entities from "../../components/Entities";

function Banners() {
  return (
    <Entities
      shema={{
        searchFromServer: true,
        searchRoute: "banners",
        fields: [
          { name: "Name", propertyName: "name", search: true },
          {
            name: "Province",
            propertyName: "provinces",
            isArray: true,
          },
        ],
      }}
    />
  );
}

export default Banners;
